import React, { Dispatch, SetStateAction } from "react";
import MenuItems from "./components/MenuItems";
import {
  StyledGrid,
  StyledGroupMenuTopNav,
  StyledRow,
} from "./multiLevelDropDown.style";
import WrapperContainer from "../WrapperContainer/WrapperContainer";

export interface IMultiLevelDropDownProps {
  isOpen?: boolean;
  sticky?: boolean;
  active?: string;
  onMultiLevelMenuClick: (item: any) => void;
  menuItems?: any;
  isUnderMarketPlace?: boolean;
  location?: any;
  hidden?: boolean;
  setExpanded: Dispatch<SetStateAction<string>>;
}

const MultiLevelDropDown: React.FC<IMultiLevelDropDownProps> = (props) => {
  const {
    onMultiLevelMenuClick,
    isOpen,
    active,
    menuItems,
    location,
    hidden,
    setExpanded
  } = props;
  
  return (
    <>
      {isOpen && menuItems?.length > 0 ? (
        <StyledGroupMenuTopNav hidden={hidden} className="marketplace-menu">
          <WrapperContainer>
            <StyledGrid>
              <StyledRow component="ul">
                {menuItems.map((menu: any, index: any) => {
                  const depthLevel = 0;
                  return (
                    <MenuItems
                      onMultiLevelMenuClick={onMultiLevelMenuClick}
                      items={menu}
                      active={active}
                      key={index}
                      depthLevel={depthLevel}
                      location={location}
                      setExpanded={setExpanded}
                    />
                  );
                })}
              </StyledRow>
            </StyledGrid>
          </WrapperContainer>
        </StyledGroupMenuTopNav>
      ) : (
        <></>
      )}
    </>
  );
};

export const defaultProps = {
  isOpen: true,
  menuItems: [],
  onMultiLevelMenuClick: () => {},
  setMultiMenuOpen: () => {},
  location: "",
  setExpanded: () => {},
};

MultiLevelDropDown.defaultProps = defaultProps;

export default MultiLevelDropDown;
